import { useState, useEffect, useRef, useCallback } from 'react';

const useDebounce = <T>(value: T, delay: number): T => {
   const [debouncedValue, setDebouncedValue] = useState(value);
   const timeoutRef = useRef<NodeJS.Timeout | null>(null);

   const clearDebounceTimeout = useCallback(() => {
      if (timeoutRef.current) {
         clearTimeout(timeoutRef.current);
      }
   }, []);

   useEffect(() => {
      clearDebounceTimeout();

      timeoutRef.current = setTimeout(() => {
         setDebouncedValue(value);
      }, delay);

      return clearDebounceTimeout;
   }, [value, delay, clearDebounceTimeout]);

   return debouncedValue;
};

export default useDebounce;
